var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronThickRight = function SvgChevronThickRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "7.05 3.52 9.9 16.97"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.465 20.485 16.95 12 8.465 3.515 7.05 4.93 14.122 12 7.05 19.071l1.415 1.414Z",
    fill: "#2E3A59"
  })));
};

export default SvgChevronThickRight;